module.exports = __webpack_public_path__ + "static/media/disciplina.f504eb72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/disciplina.svg
// module id = 199
// module chunks = 0